import React, { useState } from "react";
import axios from "axios";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"; // 👈 Heroicons

const LoginModal = ({ onLoginSuccess }) => {
    const [id, setId] = useState("");
    const [pw, setPw] = useState("");
    const [error, setError] = useState("");
    const [showPw, setShowPw] = useState(false);

    const handleLogin = async () => {
        setError("");
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_REAL_URL}/auth/login`,
                { id, pw }
            );

            if (res.data.token) {
                const token = res.data.token;
                const expiration = res.data.expiration
                    ? parseInt(res.data.expiration, 10)
                    : (new Date().getTime() + 10 * 60 * 1000);

                localStorage.setItem("auth_token", token);
                localStorage.setItem("auth_token_exp", expiration.toString());
                onLoginSuccess();
            } else {
                setError("로그인 실패");
            }
        } catch (e) {
            if (e?.response?.status === 401) {
                setError("ID/PW 를 확인해주세요");
            } else {
                setError("네트워크 오류 발생");
            }
        }
    };

    return (
        <div className="content-component-animation fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
                <h2 className="text-xl font-bold mb-4">로그인</h2>
                <input
                    value={id}
                    onChange={(e) => setId(e.target.value)}
                    placeholder="ID"
                    className="w-full mb-2 border px-3 py-2 rounded"
                />
                <div className="relative mb-2">
                    <input
                        value={pw}
                        onChange={(e) => setPw(e.target.value)}
                        type={showPw ? "text" : "password"}
                        placeholder="Password"
                        className="w-full border px-3 py-2 rounded pr-10"
                    />

                    <button
                        type="button"
                        onClick={() => setShowPw(prev => !prev)}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-700"
                        tabIndex={-1}
                        aria-label={showPw ? "비밀번호 숨기기" : "비밀번호 보기"}
                    >
                        {showPw ? <EyeIcon className="w-5 h-5"/> : <EyeSlashIcon className="w-5 h-5"/>}
                    </button>

                </div>
                {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
                <button
                    onClick={handleLogin}
                    className="bg-blue-500 text-white w-full py-2 rounded hover:bg-blue-600"
                >
                    로그인
                </button>
            </div>
        </div>
    );
};

export default LoginModal;